import './selectLang.scss';
import { useState } from 'react';
import flagMap from '../../utils/constants/flags';
import {FaChevronDown } from 'react-icons/fa';
import i18n from '../../utils/i18n';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router";

export default function SelectLang(){

    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const currentUrl = useLocation();
    const lang = currentUrl.pathname.split('/')[1];
    const changeLanguage = (e:any)=>{ 
        setIsCollapsed(false);
        i18n.changeLanguage(e);
        const urlParsed = currentUrl.pathname.split('/');
        urlParsed[1] = e;
        navigate(urlParsed.join('/'));
    }

    const displayLanguage = () => {
        setIsCollapsed(!isCollapsed);
    }



    return(
        <>
        <div className="select-lang-container">
            <div>
                <div className='select-control flex align-center gap'>
                    <span onClick={displayLanguage} className ='flex align-center gap-xs'>{t("language")} <FaChevronDown /> </span> 
                    <img src={flagMap[lang]} className='icon-img' alt='select lang' title='change language'/>
                </div>
                <ul className={`select-lang-list ${isCollapsed? 'collapsed' :''}`}>
                    <li onClick = {()=>changeLanguage('fr')}>
                        <img src={flagMap['fr']} className='icon-img'  alt='select lang' title='change language'/><span>Français</span> 
                    </li>
                    <li onClick = {()=>changeLanguage('en')}>
                        <img src={flagMap['uk']} className='icon-img'  alt='select lang' title='change language'/><span> English</span>
                    </li>
                    <li value='es' onClick = {()=>changeLanguage('es')}>
                        <img src={flagMap['es']} className='icon-img'  alt='select lang' title='change language'/><span>Español</span>
                    </li>
                </ul> 
            </div>
        </div>
        </> 
    )
}

